import { useDispatch } from 'store/hooks';

export const useNotifyCSVMessage = (
    snackType: 'success' | 'error' | 'warning',
): ((content: { message?: string }) => void) => {
    const dispatch = useDispatch();
    return (content: { message: string }) =>
        dispatch.vision.notifyUser({
            message: content.message,
            snackType,
        });
};
